var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferrals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.3763 11.9848H24.8724V10.5145C24.8724 9.88681 24.369 9.375 23.7487 9.375C23.1297 9.375 22.625 9.88681 22.625 10.5145V11.9848H21.1237C20.5034 11.9848 20 12.4966 20 13.1243C20 13.7521 20.5034 14.2639 21.1237 14.2639H22.625V15.7355C22.625 16.3632 23.1297 16.875 23.7487 16.875C24.369 16.875 24.8724 16.3632 24.8724 15.7355V14.2639H26.3763C26.9953 14.2639 27.5 13.7521 27.5 13.1243C27.5 12.4966 26.9953 11.9848 26.3763 11.9848Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 18.7695C6.81778 18.7695 2.5 19.5781 2.5 22.8084C2.5 26.0375 6.79151 26.8752 11.875 26.8752C16.931 26.8752 21.25 26.0666 21.25 22.8363C21.25 19.6059 16.9585 18.7695 11.875 18.7695Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.8752 15.6928C15.3184 15.6928 18.0785 12.8971 18.0785 9.40952C18.0785 5.92192 15.3184 3.125 11.8752 3.125C8.43195 3.125 5.67188 5.92192 5.67188 9.40952C5.67188 12.8971 8.43195 15.6928 11.8752 15.6928Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferrals);
export default __webpack_public_path__ + "static/media/referrals.a36d69c404aa355728b2622ee9c928e2.svg";
export { ForwardRef as ReactComponent };